import { PlanPurchaseProviderContextHook } from '@app/plans/src/purchase/PlanPurchaseProvider/context-hooks/PlanPurchaseProviderContextHook'
import { useEffect } from 'react'
import { usePlanPricingGroup } from '@dtx-company/inter-app/src/hooks/usePlanPricingGroup/usePlanPricingGroup'

export const usePlanPurchaseProviderPlanProperties: PlanPurchaseProviderContextHook = (
  props,
  context,
  updateContext
): void => {
  const { planType: planTypeProp } = props
  const pricingGroup = usePlanPricingGroup()

  useEffect(() => {
    updateContext({ planType: planTypeProp })
  }, [planTypeProp, updateContext])

  useEffect(() => {
    updateContext({ pricingGroup })
  }, [pricingGroup, updateContext])
}
